module.exports = __webpack_public_path__ + "img/AppStore.aec5ab6c.png";